import { render, staticRenderFns } from "./dark-layout.vue?vue&type=template&id=7f923dae&scoped=true"
import script from "./dark-layout.vue?vue&type=script&lang=ts"
export * from "./dark-layout.vue?vue&type=script&lang=ts"
import style0 from "./dark-layout.vue?vue&type=style&index=0&id=7f923dae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f923dae",
  null
  
)

export default component.exports